module.exports = __webpack_public_path__ + "static/media/img_sec_two.0c38c43f.png";